import React from 'react';

import { Box } from 'vindi-ds-components';
import {
  PrBox, PrTag, PrUser,
} from 'vindi-ds-icons/pr';
import IncompleteCard from './incomplete_card';
import CompleteCard from './complete_card';
import LockedCard from './locked_card';
import templates from './templates.json';

function getCurrentCard(status) {
  switch (status) {
    case 'completed':
      return CompleteCard;
    case 'incomplete':
      return IncompleteCard;
    default:
      return LockedCard;
  }
}

function getIconCard(template) {
  switch (template) {
    case 'product':
      return PrBox;
    case 'plan':
      return PrTag;
    default:
      return PrUser;
  }
}

function Card({
  step, template, status, linkTo, isCompleted,
}) {
  const CurrentCard = getCurrentCard(status);
  const { ...templateProps } = templates[template];

  return (
    <Box width={{ xs: '100%', lg: 'auto' }} marginBottom={isCompleted ? {} : { sm: '1rem', md: '2rem' }}>
      <CurrentCard
        {...templateProps}
        step={step}
        linkTo={linkTo}
        ButtonIcon={getIconCard(template)}
        isCompleted={isCompleted}
      />
    </Box>
  );
}

export default Card;
